import React from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import { makeStyles } from '@material-ui/core/styles';
import { Link } from "gatsby";

const useStyles = makeStyles(() => ({
  wrapper: {
    marginTop: 15,
    borderRadius: 10,
    overflow: 'hidden',
    paddingBottom: 15,
    transitionDuration: '0.25s',
    height: '100%',
    background: '#fff',
    '& h3, h4, h5': {
      padding: '0 15px',
    },
    '& h4, h5': {
      marginTop: 15,
    },
    '&:hover': {
      transform: 'scale(1.025)',
      transitionDuration: '0.25s'
    },
  }
}));

const PostCard = (props) => {

  const classes = useStyles();
  return (
    <div className={classes.wrapper + ' clickable'}>
      <Link to={props.lang === 'en-CA' ? '/en/blog/' + props.post.slug : '/blogue/' + props.post.slug}>
        <GatsbyImage image={props.post.headerImg.gatsbyImageData} alt=""/>
        <h5>{props.post.createdAt}</h5>
        <h3>{props.post.title}</h3>
        <h4>{props.post.excerpt}</h4>
      </Link>
    </div>
  )
}

export default PostCard
